import { inject, Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { tap } from 'rxjs/operators';
import {
  loadAEMSummaryContent,
  loadFutureActivity,
  loadStatusTracker
} from '../../+state/actions/status-tracker.actions';
import * as StatusTrackerSelectors from '../../+state/selectors/status-tracker.selectors';

@Injectable({
  providedIn: 'root'
})
export class StatusTrackerFacadeService {
  store = inject(Store);

  serviceConfiguration$ = this.store.pipe(
    select(StatusTrackerSelectors.getServiceConfiguration)
  );

  futureActivityRequest$ = this.store.pipe(
    select(StatusTrackerSelectors.getFutureActivityRequest)
  );

  tracker$ = this.store.pipe(
    select(StatusTrackerSelectors.getTracker),
    tap((data) => {
      if (data) {
        this.loaded = true;
      }
    })
  );

  loaded = false;

  init(aem = true): void {
    if (!this.loaded) {
      if (aem) {
        this.store.dispatch(loadAEMSummaryContent());
      }

      this.store.dispatch(loadStatusTracker());
      this.store.dispatch(loadFutureActivity());
    }
  }
}
